/* V88 "Worth What You Pay" — the ingredient rows as a slow upward ticker.

   With more rows than fit, the list shows SHOW at a time and drifts upward
   forever: the window is sized to exactly SHOW rows, the rows are cloned
   once behind themselves, and the list slides one full set up (CSS
   animation) — at the end the clones sit where the originals began, so the
   loop has no seam. Measured, not assumed, and re-measured on resize, since
   row heights change at every breakpoint. Hover or focus pauses it; reduced
   motion leaves the six standing and the rest a scroll away. */
(function () {
  var SHOW = 6;
  var SECS_PER_ROW = 2.8;

  function build(box) {
    var ul = box.querySelector('ul');
    if (!ul) return;
    [].slice.call(ul.querySelectorAll('[data-v88-clone]')).forEach(function (c) { c.remove(); });
    box.classList.remove('is-ticking', 'is-still');
    box.style.height = '';
    box.style.marginTop = '';
    ul.style.marginTop = '';

    var rows = [].slice.call(ul.children);
    if (rows.length <= SHOW) return;
    if (!rows[0].getBoundingClientRect().height) return;   // not laid out yet

    /* The list's own top margin moves onto the window, or it would sit
       inside the clipped box and push the sixth row out of view. */
    box.style.marginTop = getComputedStyle(ul).marginTop;
    ul.style.marginTop = '0px';

    var top = rows[0].getBoundingClientRect().top;
    var windowH = rows[SHOW].getBoundingClientRect().top - top;
    var gap = parseFloat(getComputedStyle(ul).rowGap || getComputedStyle(ul).gap) || 0;
    box.style.height = (windowH - gap) + 'px';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      box.classList.add('is-still');
      return;
    }
    rows.forEach(function (r) {
      var c = r.cloneNode(true);
      c.setAttribute('data-v88-clone', '');
      c.setAttribute('aria-hidden', 'true');
      ul.appendChild(c);
    });
    var travel = ul.children[rows.length].getBoundingClientRect().top - top;
    ul.style.setProperty('--v88-tick-d', travel + 'px');
    ul.style.setProperty('--v88-tick-t', (rows.length * SECS_PER_ROW) + 's');
    box.classList.add('is-ticking');
  }

  function all() { document.querySelectorAll('[data-v88-ticker]').forEach(build); }

  /* Width only: a phone fires resize as its address bar shows and hides,
     and rebuilding on that would restart the drift mid-scroll. */
  var t, w = window.innerWidth;
  function soon() {
    if (window.innerWidth === w) return;
    w = window.innerWidth;
    clearTimeout(t); t = setTimeout(all, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  window.addEventListener('load', all);          // images and fonts settle row heights
  window.addEventListener('resize', soon);
  document.addEventListener('shopify:section:load', all);
})();
